import { showNavAccount } from '@/event/account/alert/showNavAccount'
import { waitAuhenticated } from '@/storage/account/waitAuthenticated'

export function toggleShowNavAccount() {
  if (waitAuhenticated.value !== 0) showNavAccount.value = !showNavAccount.value
}
